import { gql } from "@apollo/client";
import { PageDataFragment } from "@/fragments/PageData";
import { BaseInducteeInfoFragment } from '@/fragments/InducteeInfo';
import { FlexiblePageContentFragment } from "@/fragments/FlexibleContent";

export const FrontPageQuery = gql`
${PageDataFragment}
${BaseInducteeInfoFragment}
${FlexiblePageContentFragment}
  query GetFrontPageData($databaseId: ID!, $language: String!, $asPreview: Boolean = false) {
    rhPage(id: $databaseId, asPreview: $asPreview, language: $language) {
      title
      ...PageData
      flexiblePageContent {
        ...ContentFragment
      }
      listInductees(language: $language) {
        nodes {
          ...BaseInducteeInfo
        }
      }
    }
  }
`;